import React, { useState } from 'react';

interface TrialExpiredScreenProps {
  onChangeView: (view: string) => void;
}

export const TrialExpiredScreen: React.FC<TrialExpiredScreenProps> = ({ onChangeView }) => {
  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(13,17,23,.97)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24, zIndex: 9999,
    }}>
      <div style={{
        background: 'var(--bg2)',
        border: '1px solid var(--border2)',
        borderRadius: 16,
        maxWidth: 500, width: '100%',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0,0,0,.6)',
        textAlign: 'center',
      }}>
        {/* Header */}
        <div style={{
          padding: '32px 32px 24px',
          background: 'linear-gradient(135deg, rgba(56,139,253,.08), rgba(163,113,247,.08))',
          borderBottom: '1px solid var(--border)',
        }}>
          <div style={{
            width: 64, height: 64, borderRadius: 16,
            background: 'var(--blue-dim)', border: '1px solid var(--blue-border)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px',
          }}>
            <svg width="28" height="28" fill="none" stroke="var(--blue)" strokeWidth="1.5" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
          </div>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>
            Seu período de teste encerrou
          </h2>
          <p style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.7 }}>
            Você teve 14 dias de acesso completo ao ServiceFlow. Para continuar
            gerenciando suas O.S. e equipe, escolha o plano ideal para o seu negócio.
          </p>
        </div>

        {/* Planos */}
        <div style={{ padding: '24px 32px' }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: 'var(--muted2)', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 12 }}>
            Escolha seu plano e continue de onde parou
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 24 }}>
            {[
              {
                nome: 'Starter', preco: 'R$ 149/mês', precoAnual: 'R$ 1.490/ano',
                desc: 'Até 3 técnicos · 1 admin · 1 assistente',
                color: 'var(--muted)', bg: 'var(--bg3)', border: 'var(--border)',
              },
              {
                nome: 'Pro', preco: 'R$ 299/mês', precoAnual: 'R$ 2.990/ano',
                desc: 'Até 10 técnicos · 3 admins · 3 assistentes',
                color: 'var(--blue)', bg: 'var(--blue-dim)', border: 'var(--blue-border)',
                recommended: true,
              },
              {
                nome: 'Business', preco: 'R$ 399/mês', precoAnual: 'R$ 3.990/ano',
                desc: 'Ilimitado · Todos os recursos',
                color: 'var(--purple)', bg: 'rgba(163,113,247,.1)', border: 'rgba(163,113,247,.3)',
              },
            ].map(plan => (
              <div key={plan.nome} style={{
                background: plan.bg,
                border: `1px solid ${plan.border}`,
                borderRadius: 8, padding: '12px 16px',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              }}>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: plan.color, display: 'flex', alignItems: 'center', gap: 6 }}>
                    {plan.nome}
                    {plan.recommended && (
                      <span style={{ fontSize: 10, background: 'var(--blue)', color: '#fff', padding: '1px 6px', borderRadius: 20, fontWeight: 600 }}>
                        SEU PLANO ATUAL
                      </span>
                    )}
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{plan.desc}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontFamily: 'DM Mono, monospace', fontSize: 13, fontWeight: 700, color: plan.color }}>{plan.preco}</div>
                  <div style={{ fontSize: 10, color: 'var(--muted2)', marginTop: 1 }}>{plan.precoAnual}</div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <button
            onClick={() => onChangeView('PAYMENT')}
            style={{
              width: '100%', padding: '14px',
              borderRadius: 8, fontSize: 14, fontWeight: 600,
              cursor: 'pointer', border: 'none',
              background: 'var(--blue)', color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              marginBottom: 12,
            }}
          >
            <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
              <polyline points="17 6 23 6 23 12"/>
            </svg>
            Escolher plano e continuar
          </button>

          <p style={{ fontSize: 11, color: 'var(--muted2)', lineHeight: 1.6 }}>
            Após assinar você volta exatamente de onde parou —<br/>
            todas as suas O.S. e dados estão preservados.
          </p>
        </div>
      </div>
    </div>
  );
};
